module.exports = __webpack_public_path__ + "static/media/cta-bg.3cc01059.png";